import React, { useContext } from 'react';
import { useFocusManager as $9bf71ea28793e738$export$10c5169755ce7bd7 } from '../../../../../../node_modules/@react-aria/focus/dist/FocusScope.mjs.js';
import { NavbarHelixIcon } from './NavbarHelixIcon.js';
import { getTargetSimple } from './NavbarHelpers.js';
import { NavbarContext } from './NavbarContext.js';

var NavbarMobileHelpItem = function NavbarMobileHelpItem(props) {
  var helpUrl = props.helpUrl,
      linkWrapper = props.linkWrapper,
      target = props.target; // eslint-disable-next-line react-hooks/rules-of-hooks

  var focusManager = $9bf71ea28793e738$export$10c5169755ce7bd7();

  var _useContext = useContext(NavbarContext),
      setShowMobileMenu = _useContext.setShowMobileMenu;

  var handleKeyDown = function handleKeyDown(e) {
    if (!focusManager) return;

    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        focusManager.focusNext({
          wrap: true
        });
        break;

      case 'ArrowUp':
        e.preventDefault();
        focusManager.focusPrevious({
          wrap: true
        });
        break;

      case 'End':
        e.preventDefault();
        focusManager.focusLast({});
        break;

      case 'Home':
        e.preventDefault();
        focusManager.focusFirst({});
        break;
    }
  };

  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: 'helix-unified-navbar__mobile-menu-item helix-unified-navbar__mobile-menu-help-item'
  }, React.createElement(React.Fragment, null, linkWrapper ? React.cloneElement(linkWrapper({
    url: helpUrl,
    props: {
      onKeyDown: function onKeyDown(e) {
        return handleKeyDown(e);
      },
      onClick: function onClick(e) {
        setShowMobileMenu(false);
      }
    },
    label: React.createElement(React.Fragment, null, React.createElement(NavbarHelixIcon, {
      iconName: 'question_help'
    }), " Help")
  }), {
    onKeyDown: function onKeyDown(e) {
      return handleKeyDown(e);
    },
    onClick: function onClick(e) {
      setShowMobileMenu(false);
    }
  }) : React.createElement("a", Object.assign({
    onKeyDown: function onKeyDown(e) {
      return handleKeyDown(e);
    },
    href: helpUrl,
    onClick: function onClick(e) {
      setShowMobileMenu(false);
    }
  }, getTargetSimple(target)), React.createElement(NavbarHelixIcon, {
    iconName: 'question_help'
  }), " Help"))));
};

export { NavbarMobileHelpItem as default };